import * as React from "react"
// import { Link } from "gatsby"
// import FooterSprite from "../images/sprites/footer_sprite.svg"
// import trustpilot from "../images/png/trust-pilot.png"
// import FB from "../images/facebook.svg"
import FooterVisa from "@components/ImagesComponents/FooterVisa"
import FooterMastercard from "@components/ImagesComponents/FooterMastercard"
import FooterPaypal from "@components/ImagesComponents/FooterPaypal"
import FooterFB from "@components/ImagesComponents/FooterFB"
import FooterInst from "@components/ImagesComponents/FooterInst"
import FooterTwitter from "@components/ImagesComponents/FooterTwitter"
// import FooterFBRounded from "@components/ImagesComponents/FooterFBRounded"

const Footer = () => (
    <footer className="footer">
        <div className="wrapper footer-wrapper">
            <div className="footer-base-link">
                <div className="footer-resources">
                    <h5 className="footer-title">About</h5>
                    <div className="footer-links">
                        {/* <Link to="/writing-services" className="footer-link">Writing services</Link>
                        <Link to="/testimonials" className="footer-link">Client Testimonials</Link>
                        <Link to="/order/quote" className="footer-link">Prices</Link>
                        <Link to="/info/discounts" className="footer-link">Discounts</Link> */}

                        <a href="/writing-services" className="footer-link">Writing Services</a>
                        {/* <a href="/testimonials" className="footer-link">Client Testimonials</a> */}
                        <a href="/order/quote" className="footer-link" rel="nofollow">Prices</a>
                        <a href="/info/discounts" className="footer-link" rel="nofollow">Discounts</a>
                        <a href="/info/samples" className="footer-link">Samples</a>
                    </div>
                </div>

                <div className="footer-resources">
                    <h5 className="footer-title">Resources</h5>
                    <div className="footer-links">
                        <a href="https://citemypaper.com" className="footer-link">MLA/APA/Chicago Citation Generator</a>
                        {/* <Link to="/blog" className="footer-link">Blog</Link>
                        <Link to="/essay" className="footer-link">Free Essays</Link>
                        <Link to="/support/faq" className="footer-link">FAQ</Link> */}

                        <a href="/blog" className="footer-link">Blog</a>
                        <a href="/sample-essays" className="footer-link">Sample Essays</a>
                        <a href="/support/faq" className="footer-link" rel="nofollow">FAQ</a>

                        <a href="https://shop.customessaymeister.com/terms" rel="nofollow" className="footer-link">Terms Of Service</a>
                        <a href="https://shop.customessaymeister.com/privacy" rel="nofollow" className="footer-link">Privacy Policy</a>
                    </div>
                </div>

                <div className="footer-resources">
                    <h5 className="footer-title">Shortcuts</h5>
                    <div className="footer-links">
                        <a href="https://shop.customessaymeister.com/order/express" rel="nofollow" className="footer-link">New Order</a>
                        <a href="https://shop.customessaymeister.com/support/ticket/new" rel="nofollow" className="footer-link">Support Center</a>
                    </div>
                </div>

                <div className="footer-support">
                    <div className="footer-title">We are open!</div>
                    <p className="footer-description">Our support team is here 24/7 via live chat, phone and on-line support ticketing system.</p>
                    <a href="https://shop.customessaymeister.com/support/ticket/new" rel="nofollow" className="button button-primary">ask a question</a>
                </div>
            </div>

            <div className="footer-social">
                <div className="footer-title">Follow us</div>
                <div className="footer-social__wrapper">
                    <div className="footer-social__img">
                        <a href="https://www.facebook.com/essaymeister" target="_blank" rel="nofollow noreferrer ">
                            <FooterFB />
                        </a>
                    </div>
                    <div className="footer-social__img">
                        <a href="https://www.instagram.com/customessaymeister" target="_blank" rel="nofollow noreferrer ">
                            <FooterInst />
                        </a>
                    </div>
                    <div className="footer-social__img">
                        <a href="https://twitter.com/essay_meister" target="_blank" rel="nofollow noreferrer ">
                            <FooterTwitter />
                        </a>
                    </div>
                </div>
            </div>

            {/* <div className="footer-rating">
                <div className="footer-title">Rating</div>
                <div className="footer-rating-wrapper">
                    <a href="https://www.trustpilot.com/review/customessaymeister.com" target="_blank" rel="nofollow noreferrer ">
                        <img data-src={trustpilot} alt="trustpilot" width={24} height={24} className="lazyload" />
                        <span>3.7 / 5</span> <span>Trustpilot</span>
                    </a>
                    <a href="https://www.facebook.com/essaymeister" target="_blank" rel="nofollow noreferrer ">
                        <FooterFBRounded />
                        <span>4.3 / 5</span> <span>Facebook</span>
                    </a>
                </div>
            </div> */}

            <div className="footer-payments">
                <div className="footer-title">Payments Accepted</div>
                <div className="footer-payments__images">
                    <div className="footer-payments__img">
                        <FooterVisa />
                    </div>
                    <div className="footer-payments__img">
                        <FooterMastercard />
                    </div>
                    <div className="footer-payments__img">
                        <FooterPaypal />
                    </div>
                </div>
            </div>


        </div>
        <div className="wrapper footer-copyright">
            {new Date().getFullYear()}
            <span>Customessaymeister.com</span>
        </div>
    </footer>
)

export default Footer
